import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["AvatarBadge", "children", "onClick", "type"];
import { memo, useEffect, useMemo, useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { delayUntilIdle } from '../lib/delayUntilIdle';
import AvatarHover from './baseStyledComponents/AvatarHover';
import { getAvatarContentProps, getAvatarContentWrapperProps, getAvatarHoverProps } from '../lib/displayUtils';
import { Caption } from './components/Caption';
import { AvatarContentWrapper } from './components/AvatarContentWrapper';
import { AvatarContent } from './components/AvatarContent';
import { getDefaultAvatarType } from '../lib/getDefaultAvatarType';
import { DEFAULT_PROPS } from '../Constants';
import { AvatarBadgeHolder } from './components/AvatarBadgeHolder';
import { useParsedColorScheme } from './hooks/useParsedColorScheme';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const __TrellisAvatarDisplay = _ref => {
  let {
      AvatarBadge,
      children,
      onClick,
      type
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const propsWithDefaults = Object.assign({}, DEFAULT_PROPS, rest);
  const [isTooltipLoaded, setIsTooltipLoaded] = useState(false);
  useEffect(() => {
    const clear = delayUntilIdle(() => setIsTooltipLoaded(true));
    return () => clear();
  }, []);
  const iconType = useMemo(() => getDefaultAvatarType(type), [type]);
  const {
    parsedBackgroundColor,
    parsedIconColor
  } = useParsedColorScheme(iconType);
  const passedProps = Object.assign({}, propsWithDefaults, rest, {
    backgroundColor: parsedBackgroundColor,
    iconColor: parsedIconColor,
    onClick,
    type,
    iconType
  });
  const avatarHoverProps = getAvatarHoverProps(passedProps, {
    isTooltipLoaded
  });
  const avatarContentWrapperProps = getAvatarContentWrapperProps(passedProps);
  const avatarContentProps = getAvatarContentProps(passedProps);
  if (children) {
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(AvatarHover, Object.assign({}, avatarHoverProps, {
        children: /*#__PURE__*/_jsx(AvatarContentWrapper, Object.assign({}, avatarContentWrapperProps, {
          children: /*#__PURE__*/_jsx(AvatarContent, Object.assign({}, avatarContentProps))
        }))
      })), /*#__PURE__*/_jsx(Caption, {
        childMarginInlineStart: passedProps.childMarginInlineStart,
        childTruncateLength: passedProps.childTruncateLength,
        onClick: onClick,
        children: children
      })]
    });
  }
  return /*#__PURE__*/_jsxs(AvatarHover, Object.assign({}, avatarHoverProps, {
    children: [/*#__PURE__*/_jsx(AvatarContentWrapper, Object.assign({}, avatarContentWrapperProps, {
      children: /*#__PURE__*/_jsx(AvatarContent, Object.assign({}, avatarContentProps))
    })), /*#__PURE__*/_jsx(AvatarBadgeHolder, {
      AvatarBadge: AvatarBadge,
      size: propsWithDefaults.size
    })]
  }));
};
export const TrellisAvatarDisplay = /*#__PURE__*/memo(__TrellisAvatarDisplay);